import styled from 'styled-components';
import { getContrastColor } from '../../utils/colorUtils';

// Normaliza hex a 6 dígitos para comparaciones correctas (#000 → #000000)
export const normalizeHex = (hex) => {
  if (!hex) return '#000000';
  const h = hex.replace('#', '');
  if (h.length === 3) return '#' + h.split('').map(c => c + c).join('');
  return '#' + h.toLowerCase();
};

export const Container = styled.div`
  width: 100%;
  padding: 40px 20px;
  background-color: ${props => props.bgColor};
  min-height: 80vh;
  transition: background-color 0.3s ease;

  @media (max-width: 768px) { padding: 20px 12px; }
`;

export const Title = styled.h1`
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-size: 32px;
  margin-bottom: 30px;
  text-align: center;
`;

export const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
`;

export const SettingCard = styled.div`
  background: ${props => props.bgColor};
  padding: 25px;
  border-radius: 10px;
  border: 1px solid ${props => props.borderColor || '#333'};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s ease;
`;

export const SettingTitle = styled.h2`
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-size: 18px;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
`;

export const ColorOption = styled.button`
  width: 100%;
  padding: 15px;
  border: 3px solid ${props => props.selected ? '#fff' : '#333'};
  border-radius: 8px;
  background-color: ${props => props.color};
  color: ${props => getContrastColor(props.color || '#000000')};
  cursor: pointer;
  transition: all 0.3s;
  position: relative;

  &:hover { border-color: #fff; transform: scale(1.05); }
  ${props => props.selected && `box-shadow: 0 0 20px ${props.color};`}
`;

export const ColorLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  display: block;
  margin-top: 5px;
  color: ${props => props.textColor || 'inherit'};
`;

export const ThemeOption = styled.button`
  width: 100%;
  padding: 15px;
  border: 2px solid ${props => props.selected ? '#fff' : '#444'};
  border-radius: 8px;
  background: ${props => props.background};
  color: ${props => props.color};
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 600;
  margin-bottom: 10px;

  &:hover { border-color: #fff; transform: translateX(5px); }
`;

export const PreviewBox = styled.div`
  background: ${props => props.bgColor};
  color: ${props => props.textColor};
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  margin-top: 15px;
  border: 1px solid ${props => props.borderColor};
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;
`;

export const Button = styled.button`
  padding: 14px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  width: 30%;

  ${props => props.primary ? `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    &:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4); }
  ` : `
    background: #333;
    color: #fff;
    border: 2px solid #555;
    &:hover { background: #444; border-color: #777; }
  `}
`;
